// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionUpsalesForm_container__B7Y68","marginBottom":"SectionUpsalesForm_marginBottom__tqEiF","center":"SectionUpsalesForm_center__4uPr5"};